import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-14 px-4 bg-[#0a0a0a] border-t border-[#333]" data-id="element-35">
      <div className="max-w-3xl mx-auto text-center" data-id="element-36">
        <div className="flex justify-center mb-6" data-id="element-37">
          <Shield className="w-16 h-16 text-[#c8b89a]" data-id="element-38" />
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 font-['Special_Elite'] uppercase" data-id="element-39">
          Nuestra Garantía "Caso Cerrado"
        </h2>

        <div className="bg-[#151515] border border-[#333] p-8 rounded-sm relative" data-id="element-40">
          <p className="text-gray-300 text-lg leading-relaxed mb-6" data-id="element-41">
            Estamos tan seguros de que este será el mejor plan que has
            organizado en años, que si tras abrir el primer sobre sientes que no
            es para ti, te devolvemos el 100% de tu dinero.
          </p>
          <p className="text-[#c8b89a] font-bold font-mono" data-id="element-42">
            Sin preguntas. Sin letra pequeña. Tienes 30 días para decidir.
          </p>
        </div>
      </div>
    </section>;
}